import React, { FC } from "react";
import { Card } from "antd";
import Engine from "../../../components/Engine";

const EngineApp: FC = () => {
  return (
    <Card loading={false}>
      <Engine />
    </Card>
  );
};

export default EngineApp;
